<template>
  <div class='users'>
    <div class="table-row header">
      <div class="name" @click="sortData('name')"><span>Username</span><SortIcon column="name" :sortProperty="$store.getters.usersSortProp" :sortAscending="$store.getters.usersSortAscending"></SortIcon></div>
      <div class="full-name" @click="sortData('fullName')"><span>Name</span><SortIcon column="fullName" :sortProperty="$store.getters.usersSortProp" :sortAscending="$store.getters.usersSortAscending"></SortIcon></div>
      <div class="role" @click="sortData('roleName')"><span>Role</span><SortIcon column="role" :sortProperty="$store.getters.usersSortProp" :sortAscending="$store.getters.usersSortAscending"></SortIcon></div>
    </div>

    <RecycleScroller :items="users" :item-height="30" class="users-table">
      <div slot-scope="{ item }" class="table-row" @click="editUser(item, $event)">
        <div class="name">{{item.name}}</div>
        <div class="full-name">{{item.fullName}}</div>
        <div class="role">{{item.roleName}}</div>
      </div>
    </RecycleScroller>
    <el-dialog :visible.sync="userDialogIsVisible" class="user-dialog" width="500px" top="50px" title="Edit User" :close-on-click-modal="false" v-draggable>
      <UserDialog :user="selectedUser" :close="closeUserDialog"></UserDialog>
    </el-dialog>
  </div>
</template>

<script>

import SortIcon from '@/components/SortIcon'
import UserDialog from '@/components/UserDialog'

export default {
  components: {
    SortIcon,
    UserDialog
  },
  data () {
    return {
      userDialogIsVisible: false,
      selectedUser: null
    }
  },
  computed: {
    users () {
      let sortOrder = this.$store.getters.usersSortAscending === true ? 1 : -1
      let sortProp = this.$store.getters.usersSortProp

      return this.$store.getters.users.sort((a, b) => {
        let aValue = a[sortProp] ? a[sortProp].toLowerCase() : ''
        let bValue = b[sortProp] ? b[sortProp].toLowerCase() : ''
        return aValue > bValue ? sortOrder : aValue < bValue ? sortOrder * -1 : 0
      })
    }
  },
  methods: {
    editUser (user, event) {
      if (event.detail > 1) {
        return
      }

      this.userDialogIsVisible = true
      this.selectedUser = user
    },
    closeUserDialog () {
      this.userDialogIsVisible = false
    },
    sortData (prop) {
      if (prop === this.$store.getters.usersSortProp) {
        this.$store.commit('toggleUsersSortAscending')
      } else {
        this.$store.commit('setUsersSortAscending', true)
      }
      this.$store.commit('setUsersSortProp', prop)
    }
  }
}
</script>

<style lang='scss' >
@import '../styles/common.scss';

.users {
  height: 100%;
  box-sizing: border-box;
  padding: 20px !important;

  .vue-recycle-scroller__item-view {
    width: initial !important;
    height: 31px;
    right: 0px;
  }
  .users-table {
    height: calc(100vh - 290px);
    color: #606266;
  }
  .table-row {
    display: table;
    table-layout: fixed;
    border-bottom: 1px solid $table-border-color;
    height: 30px;
    width: 100%;

    > div {
      display: table-cell;
      white-space: nowrap;
      vertical-align: middle;
      padding-right: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.header {
      font-weight: bold;
      color: gray;
      text-transform: uppercase;
      height: 25px;

      &:hover {
        background: none;
      }
    }
    &:hover {
      background: $table-hover-color;
    }
    .full-name {
      width: 250px !important;
    }
    .name {
      width: 200px !important;
    }
    .role {
      width: 100% !important;
    }
  }
}
</style>

